/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Design = M.View.Design || {};

  /**
   * @class M.View.Design.PollVote
   * Displays a dialog showing the user's current option choice. Allows user
   * to select next and previous option to move through the options and modify
   * their selection. Finally, the user can submit their vote.
   */
  M.View.Design.PollVote = Backbone.View.extend({
    tagName: 'div',
    className: 'voteDialog hide',
    events: {
      'click .cancel': 'close',
      'click .prev': 'prevOption',
      'click .next': 'nextOption',
      'click .vote': 'vote'
    },

    template: M.Template.Design.PollVote,

    initialize: function() {
      this.$el = $(this.el);
      this.optionViews = this.options.optionViews;
      this.poll = this.options.poll;
      this.index = this.options.index;
      this.onVoteSuccessFcn = this.options.onVoteSuccessFcn || this.onVoteSuccess;
      _.bindAll(this, 'onVoteSuccess');
      this.updateModel();
    },

    updateModel: function () {
      this.optionView = this.optionViews[this.index];
      this.model = new M.Model.Design.PollVote({
        user: this.options.user,
        option: this.optionView.model,
        urlPaths: this.options.urlPaths
      });
    },

    render: function() {
      this.$el.html(this.template());
      this.$el.dialog({
        title: 'which design do you prefer?',
        modal: true,
        width: 500,
        draggable: false
      });
      this.option = this.$('.option');
      this.optionImage = this.option.find('img');
      this.optionName = this.option.find('.optionName');
      this.setUpPrevNext();
      this.updateOption();
      return this;
    },

    /**
     * Update the option displayed in this dialog as well as the underlying
     * model to this view.
     */
    updateOption: function() {
      this.updateModel();
      var image = new Image();
      image.src = this.model.get('option').get('image');
      image.onload = _.bind(function() {
        // Update the width of the images parent to match the image.
        this.option.width(this.optionImage.width());
      }, this);
      this.optionImage.attr('src', image.src);
      this.optionName.html(this.optionView.optionName);
    },

    setUpPrevNext: function() {
      this.prev = this.$('.prev', this.option);
      this.next = this.$('.next', this.option);
      this.togglePrevNextDisabled();
    },

    /**
     * Determines whether or not the prev and next buttons will be enabled.
     * prev is enabled only if this.index is > 0. Next is enabled only if
     * this.index is less than the index of the last option. Sets the
     * 'disabled' property on each button.
     */
    togglePrevNextDisabled: function() {
      if (this.index <= 0) {
        this.prev.prop('disabled', true);
      } else {
        this.prev.prop('disabled', false);
      }

      var options = this.poll.get('options');
      if (this.index >= options.length - 1) {
        this.next.prop('disabled', true);
      } else {
        this.next.prop('disabled', false);
      }
    },

    /**
     * Selects and renders the previous option in the option list.
     */
    prevOption: function() {
      if (!this.prev.prop('disabled')) {
        this.index = Math.max(this.index - 1, 0);
        this.togglePrevNextDisabled();
        this.updateOption();
      }
    },

    /**
     * Selects and renders the next option in the option list.
     */
    nextOption: function() {
      if (!this.next.prop('disabled')) {
        var options = this.poll.get('options');
        this.index = Math.min(this.index + 1, options.length - 1);
        this.togglePrevNextDisabled();
        this.updateOption();
      }
    },

    /**
     * Send the vote to the server and render the vote success view.
     */
    vote: function() {
      var that = this;
      this.model.save().then(
        function() {
          that.onVoteSuccessFcn();
        }, function() {
          window.location = '/login?destination=' + encodeURIComponent(window.location);
        }
      );
    },
 
    onVoteSuccess: function() {
      var successView = new M.View.Design.PollVoteSuccess({
        model: this.model,
        optionView: this.optionView,
        poll: this.poll,
        // currently only pass-through to community comment model
        urlPaths: this.options.urlPaths
      });
      successView.render();
      this.close();
    },

    close: function() {
      this.$el.dialog('close');
    }
  });

})(M, _, $, Backbone);

